<template>
  <div>
    <page-header v-if="!!dictionary">
      <template #breadcrumbs>
        {{ dictionary.title }}
      </template>
      <h2>{{ dictionary.title }}</h2>
      <template #actions>
        <div class="actions d-flex" style="align-items:center;">
          <button-component
            v-if="dictionary.isImportable && canRmisEdit"
            class="mx-2"
            @click="importDict(dictionary.id)"
          >
            Обновить данные из ЕЦП
          </button-component>
          <button-component
            class="mx-2"
            v-if="canImportExcel"
            @click="importExcel()"
          >
            Загрузить из Excel
          </button-component>

          <button-component v-if="canEdit" class="mx-2" @click="editCard(0)">
            Создать
          </button-component>
          <button-component
            class="mx-2"
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>
    <section class="content">
      <template v-if="page && dictionary">
        <template v-if="page.items && page.items.length">
          <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="50px" v-if="!dictionary.isReadonly"></th>
                  <th width="5%" class="text-center">ID</th>
                  <th v-if="name === 'organizationsubtype'">Тип организации</th>
                  <th
                    v-if="
                      name === 'educationalprogram' ||
                      name === 'classlevel' ||
                      name === 'classkind'
                    "
                  >
                    Уровень образования
                  </th>
                  <th v-if="name === 'educationform'">Категория обучения</th>
                  <th
                    v-if="
                      name === 'recomspeechtherapy' ||
                      name === 'recompedagogical' ||
                      name === 'recompsychological'
                    "
                  >
                    Образовательная программа
                  </th>
                  <th v-if="name === 'opf'">ОПФ</th>
                  <th v-else>Название</th>
                  <th
                    v-if="
                      name === 'state' ||
                      name === 'region' ||
                      name === 'country' ||
                      dictionary.isImportable
                    "
                  >
                    Код
                  </th>
                  <th v-if="name === 'opf'">Форма собственности</th>
                  <th
                    v-if="name === 'organizationtype' || name === 'servicetype'"
                  >
                    Вид деятельности
                  </th>
                  <th v-if="name === 'region'">Государство</th>
                  <th v-if="name === 'district'">Субъект государства</th>
                  <th>Дата создания</th>
                  <th>Дата изменения</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in page.items"
                  :key="item.id"
                  v-on:dblclick="editCard(item.id)"
                >
                  <td v-if="!dictionary.isReadonly">
                    <menu-component class="actions" :actions="actions(item)" />
                  </td>
                  <td class="text-center">
                    {{ dictionary.isImportable ? item.externalId : item.id }}
                  </td>
                  <td v-if="name === 'organizationsubtype'">
                    {{ item.organizationType?.name }}
                  </td>
                  <td
                    v-if="
                      name === 'educationalprogram' ||
                      name === 'classlevel' ||
                      name === 'classkind'
                    "
                  >
                    {{ item.educationLevel?.name }}
                  </td>
                  <td v-if="name === 'educationform'">
                    {{ item.educationCategory?.name }}
                  </td>
                  <td
                    v-if="
                      name === 'recomspeechtherapy' ||
                      name === 'recompedagogical' ||
                      name === 'recompsychological'
                    "
                  >
                    {{ item.educationalProgram?.educationLevel?.name }} /
                    {{ item.educationalProgram?.name }}
                  </td>
                  <td v-if="name === 'opf'">
                    <template v-if="item.parentId">{{ item.name }}</template>
                    <template v-else>&mdash;</template>
                  </td>
                  <td
                    :style="
                      dictionary.name !== 'Diag' || !item.code
                        ? ''
                        : (item.code && item.code.length > 3
                            ? 'font-weight:bold;'
                            : '') +
                          (item.parentId && item.code.length > 3
                            ? 'padding-left:100px'
                            : '') +
                          (item.parentId && item.code.length === 3
                            ? 'padding-left:200px'
                            : '')
                    "
                    v-else
                  >
                    <i
                      class="fa fa-folder"
                      v-if="dictionary.name === 'Diag' && item.code.length > 3"
                    />
                    {{ item.name }}
                  </td>
                  <td
                    v-if="
                      name === 'state' ||
                      name === 'region' ||
                      name === 'country' ||
                      dictionary.isImportable
                    "
                  >
                    {{ item.code }}
                  </td>
                  <td v-if="name === 'opf'">
                    <template v-if="item.parentId">{{
                      item.parent?.name
                    }}</template>
                    <template v-else>{{ item.name }}</template>
                  </td>
                  <td
                    v-if="name === 'organizationtype' || name === 'servicetype'"
                  >
                    {{ item.kindActivity?.name }}
                  </td>
                  <td v-if="name === 'region'">{{ item.state?.name }}</td>
                  <td v-if="name === 'district'">{{ item.region?.name }}</td>
                  <td>{{ $momentFormat(item.created, "DD.MM.YYYY HH:mm") }}</td>
                  <td>
                    {{ $momentFormat(item.modified, "DD.MM.YYYY HH:mm") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="page.pagesTotal > 1">
            <Pagination
              :page-count="page.pagesTotal"
              :current-page="page.pageNumber"
              @change="onPageChange($event)"
            />
          </div>
          <div>
            <PageCounter
              :isFiltered="isFiltered"
              :totalCount="totalCount"
              :filteredCount="page.itemsTotal"
            />
          </div>
        </template>
        <template v-else>
          <EmptyListMessage />
        </template>
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <DictionaryItemsFilter
              v-bind:dict-name="name"
              v-bind:is-importable="dictionary.isImportable"
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
        <modal-component
          v-if="modals.importDict"
          title="Импорт справочника"
          size-class=""
          @close="modals.importDict = false"
        >
          <import-dictionary
            v-on:doimport="doImport"
            @close="modals.importDict = false"
          />
        </modal-component>
      </section>
    </section>
  </div>
</template>

<script>
import PageHeader from "../../../common/components/page/PageHeader";
import { mapState } from "vuex";
import EmptyListMessage from "../../../common/components/EmptyListMessage";
import ButtonComponent from "../../../common/ui/ButtonComponent";
import IconComponent from "../../../common/ui/IconComponent";
import DictionaryItemsFilter from "../components/DictionaryItemsFilter";
import Constants from "../../../common/constants";
import API from "../api/nsi";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import security from "../../../common/mixins/security";
import ImportDictionary from "../components/ImportDictionary";
import ModalComponent from "../../../common/ui/ModalComponent";
import PageCounter from "@/common/components/PageCounter";
export default {
  name: "DictionaryItems",
  components: {
    ModalComponent,
    ImportDictionary,
    MenuComponent,
    DictionaryItemsFilter,
    IconComponent,
    ButtonComponent,
    EmptyListMessage,
    PageHeader,
    PageCounter,
  },
  mixins: [security, filtermanager],
  created() {
    //загрузить по-умолчанию
    this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
    this.checkPermission(Constants.RmisDictionaryEdit)
      .then((response) => {
        this.canRmisEdit = response.data;
      })
      .catch(() => {
        this.canRmisEdit = false;
      });
    this.checkPermission(Constants.DictionaryEdit)
      .then((response) => {
        this.canSysEdit = response.data;
      })
      .catch(() => {
        this.canSysEdit = false;
      });

    this.getTotalCount();

    this.loadPage();
  },
  mounted() {
    console.log(this.$route);
  },
  data() {
    return {
      name: this.$route.params.name,
      request: {
        dictName: this.$route.params.name,
        pageNumber: 1,
        pageSize: Constants.pageSize,
      },
      filters: {
        name: "",
        code: "",
        referenceId: 0,
      },
      modals: {
        filter: false,
        importDict: false,
      },
      isFiltered: false,
      totalCount: 0,
      canRmisEdit: true,
      canSysEdit: true,
    };
  },
  methods: {
    getTotalCount() {
      const self = this;
      API.getItems({
        dictName: this.$route.params.name,
        pageNumber: 1,
        pageSize: 1,
      }).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      let result = [
        {
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.id),
        },
      ];
      if (this.canEdit && (this.name !== "country" || !item.isRf)) {
        result = result.concat([
          {
            title: "Редактировать",
            icon: "pen",
            click: () => this.editCard(item.id),
          },
          {
            title: "Удалить",
            icon: "trash",
            click: () => this.deleteCard(item),
          },
        ]);
      }
      return result;
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      this.$store.dispatch("admin/nsi/getDictionary", this.name);
      this.$store.dispatch(
        "admin/nsi/searchNsi",
        Object.assign(this.filters, this.request)
      );
    },
    importDict(id) {
      API.importRMIS(id).then((res) => {
        if (res.data.success) {
          Constants.alert.fire("Обновление справочника", "Успешно", "success");
          this.loadPage();
        } else {
          Constants.alert.fire(
            "Обновление справочника",
            "Ошибка при обновлении справочника. " + res.data.message,
            "error"
          );
        }
      });
    },
    viewCard(id) {
      this.$router.push({
        name: "dictionaryItemCard",
        params: { name: this.name, action: "view", id: id },
        query: { page: this.request.pageNumber }
      });
    },
    editCard(id) {
      if (this.canEdit) {
        // this.$router.push({
        //   path: `/admin/dictionary/${this.name}/edit/${id}`,
        // });
        this.$router.push({
          name: "dictionaryItemCard",
          params: { name: this.name, action: "edit", id: id },
          query: { page: this.request.pageNumber }
        });
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(item) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(this.name, item.id)
            .then(() => {
              Constants.alert.fire(
                "Удаление",
                "Запись справочника удалена.",
                "success"
              );              
              this.loadPage();
              this.getTotalCount();
            })
            .catch(() => {
              Constants.alert.fire(
                "Удаление",
                "Ошибка при удалении записи справочника.",
                "error"
              );
            });
        }
      });
    },
    importExcel() {
      this.modals.importDict = true;
    },
    doImport(file) {
      this.modals.importDict = false;
      API.importExcel(this.name, file)
        .then((response) => {
          if (response.data.success) {
            Constants.alert.fire("Импорт", response.data.message, "success");
          } else {
            Constants.alert.fire("Импорт", response.data.message, "error");
          }
          this.loadPage();
        })
        .catch(() => {
          Constants.alert.fire(
            "Импорт",
            "Ошибка при импорте справочника.",
            "error"
          );
        });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.$router.push({
          query: {
              ...this.$route.query,
              page: pageNumber
            }
      });
      this.loadPage();
    },
  },
  computed: {
    ...mapState({
      dictionary: (state) => state.admin.nsi.dictionary,
      page: (state) => state.admin.nsi.listPage,
    }),
    canImportExcel() {
      const dicts = [
        "recomspeechtherapy",
        "recompedagogical",
        "recompsychological",
      ];
      return (
        dicts.indexOf(this.name) > -1 &&
        !this.dictionary.isImportable &&
        this.canSysEdit
      );
    },
    canEdit() {
      return this.dictionary.isImportable ? this.canRmisEdit : this.canSysEdit;
    },
  },
  watch: {
    '$route.query.page': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
</style>
